import Vue from 'vue';
import Vuex from 'vuex';
import articles from '@/store/articles';

export default () => {
  Vue.use(Vuex);

  return new Vuex.Store({
    state: {},
    modules: {
      articles,
    },
  });
};
